import type { DetectionMetadata } from '../../query-intent-api/types';
import type { RequestOverviewData } from './types';

export const normalizeDetectionMetadata = (
	detectionMetadata: DetectionMetadata | undefined,
): RequestOverviewData['detectionMetadata'] =>
	detectionMetadata
		? {
				method: detectionMetadata.method ?? null,
				model: detectionMetadata.model ?? null,
				latencyMs:
					typeof detectionMetadata.latencyMs === 'number' ? detectionMetadata.latencyMs : null,
				cacheHit:
					typeof detectionMetadata.cacheHit === 'boolean' ? detectionMetadata.cacheHit : null,
			}
		: null;
